import api from "../api";
import config from "../config";

export const authService = {
  login: async ({ username, password }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/login/`, {
      username,
      password,
    });
    return res.data;
  },

  refresh: async ({ refresh }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/token/refresh/`, {
      refresh,
    });
    return res.data;
  },

  register: async ({ email, password, password_confirm, first_name, last_name, country_code, accept_terms, share_contacts }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/auth/register/`, {
      email,
      password,
      password_confirm,
      ...(first_name ? { first_name } : {}),
      ...(last_name ? { last_name } : {}),
      ...(country_code ? { country_code } : {}),
      ...(accept_terms !== undefined ? { accept_terms } : {}),
      ...(share_contacts !== undefined ? { share_contacts } : {}),
    });
    return res.data;
  },

  confirmEmail: async ({ uid, token }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/auth/confirm-email/`, {
      uid,
      token,
    });
    return res.data;
  },

  resendConfirmation: async (email) => {
    const res = await api.post(
      `${config.apiBaseUrl}/api/auth/resend-confirmation/`,
      { email },
    );
    return res.data;
  },

  logout: async () => {
    const res = await api.post(`${config.apiBaseUrl}/api/logout/`);
    return res.data;
  },

  me: async ({ access }) => {
    const res = await api.get(`${config.apiBaseUrl}/api/usuarios/me/`, {
      headers: { Authorization: `Bearer ${access}` },
    });
    return res.data;
  },

  updateMe: async (payload, options = {}) => {
    const token = localStorage.getItem("access_token");

    const isFormData = payload instanceof FormData;

    const {
      headers: optionHeaders = {},
      ...restOptions
    } = options;

    const res = await api.put(
      `${config.apiBaseUrl}/api/usuarios/me/`,
      payload,
      {
        ...restOptions,
        headers: {
          Authorization: `Bearer ${token}`,

          ...(isFormData ? {} : { "Content-Type": "application/json" }),

          ...optionHeaders,
        },
      }
    );

    return res.data;
  },

  requestPasswordReset: async (email) => {
    const { data } = await api.post(
      `${config.apiBaseUrl}/api/usuarios/password-reset/request/`,
      {
        email,
      },
    );
    return data;
  },

  confirmPasswordReset: async ({
    uid,
    token,
    new_password,
    re_new_password,
  }) => {
    const { data } = await api.post(
      `${config.apiBaseUrl}/api/usuarios/password-reset/confirm/`,
      {
        uid,
        token,
        new_password,
        re_new_password,
      },
    );
    return data;
  },
};
